import NavbarListItemSelect from 'modules/common/Navbar/NavbarListItems/NavbarListItemSelect';
import LanguageProvider from 'providers/LanguageProvider';
import React, { PureComponent } from 'react';
import MoneyIcon from 'components/icons/MoneyIcon';
import { addFlux, AddFluxHOCProps } from 'components/wrappers/WithFlux';
import { useCurrencyContext } from '~/context/CurrencyContext';
import CurrencyList from 'utils/CurrencyList';
import GlobeIcon from 'components/icons/GlobeIcon';

const CSS = require('./NavbarList.less');

function CurrencyListItem() {
  const { state, actions } = useCurrencyContext();
  const onCurrencyChange = (event) => {
    actions.setCurrency(event.target.value);
  };

  return (
    <li className={CSS.MenuItem}>
      <NavbarListItemSelect
        value={state.currency}
        options={CurrencyList.map(({ symbol_native, code }) => ({ value: code, name: `${code} - ${symbol_native}` }))}
        onChange={onCurrencyChange}
      />
      <div className={CSS.IconContainer}>
        <MoneyIcon className={CSS.Icon} width={29} height={19}/>
      </div>
    </li>
  );
}

class LanguageListItem extends PureComponent<AddFluxHOCProps> {
  onLanguageChange = (event) => {
    const langCode = event.target.value.toLowerCase();
    this.props.flux.actions.translations.setLanguageCode(langCode);
  };

  render() {
    return (
      <li className={CSS.MenuItem}>
        <LanguageProvider>
          {({ language, languages }) =>
            <NavbarListItemSelect
              value={language.toLowerCase()}
              options={languages.map(lng => ({ value: lng.code, name: `${lng.code.toUpperCase()} - ${lng.name}` }))}
              onChange={this.onLanguageChange}
            />
          }
        </LanguageProvider>
        <div className={CSS.IconContainer}>
          <GlobeIcon className={CSS.Icon} width={24} height={24}/>
        </div>
      </li>
    );
  }
}

const currencyListItem = addFlux<{}>(CurrencyListItem);
const languageListItem = addFlux<{}>(LanguageListItem);
export {
  languageListItem as LanguageListItem,
  currencyListItem as CurrencyListItem
};
